// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--1svf3","icon":"styles-module--icon--1-782","label":"styles-module--label--2KTen","light":"styles-module--light--1kLe3"};